/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tradeorbrandnamerequired4Inputs */

const en_tradeorbrandnamerequired4 = /** @type {(inputs: Tradeorbrandnamerequired4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trade / brand name is required`)
};

const de_tradeorbrandnamerequired4 = /** @type {(inputs: Tradeorbrandnamerequired4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Handelsname/Markenname ist erforderlich`)
};

/**
* | output |
* | --- |
* | "Trade / brand name is required" |
*
* @param {Tradeorbrandnamerequired4Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const tradeorbrandnamerequired4 = /** @type {((inputs?: Tradeorbrandnamerequired4Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tradeorbrandnamerequired4Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_tradeorbrandnamerequired4(inputs)
	return de_tradeorbrandnamerequired4(inputs)
});
export { tradeorbrandnamerequired4 as "tradeOrBrandNameRequired" }